var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCall = function SvgCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.816,
    height: 72.816,
    viewBox: "0 0 72.816 72.816",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16699",
    "data-name": "Group 16699",
    transform: "translate(-143 -805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M36.408,0A36.408,36.408,0,1,1,0,36.408,36.408,36.408,0,0,1,36.408,0Z",
    transform: "translate(143 805)",
    fill: "#4cd964"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_677116_cc",
    transform: "translate(168 829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M28.955,35.874a14.467,14.467,0,0,0,1.828-.114l.341-.044.2-.279c1.985-2.775,1.6-5.737,1.667-8.2L33,26.87l-.276-.245c-2.473-2.2-2.932-2.466-6.208-2.428l-.258,0-.208.155c-.852.635-2.584,1.222-3.427,2.27-1.229-.614-5.257-2.866-6.973-4.952S11.961,16.525,11.6,15.2c1.192-.626,1.834-1.933,2.621-2.644l.192-.174.053-.253a11.487,11.487,0,0,0-1.384-8.746l-.189-.322L12.524,3A13.764,13.764,0,0,0,4.4,4.1l-.313.142-.11.327c-1.43,4.249-.322,12.118,7.09,21.489C18.235,34.45,25.113,35.874,28.955,35.874Z",
    transform: "translate(-6.351 -6.931)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call.93033b7a.svg";
export { ForwardRef as ReactComponent };